"use client";

import type React from "react";
import CButton from "@/Shared/CButton/CButton";

interface Props {
  email: string;
  setEmail: (v: string) => void;
  onRequest: () => void;
  loading?: boolean;
}

/**
 * RequestStep — email input + send button.
 *
 * Inlined here (instead of using a DynamicForm) because the staff-mgmt
 * project doesn't ship the full Shared/Form infrastructure yet.
 *
 * The button says "Send reset link", not "Send OTP": auth-gateway emails a
 * link, and there is no code to enter.
 */
const RequestStep: React.FC<Props> = ({
  email,
  setEmail,
  onRequest,
  loading = false,
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onRequest();
      }}
      className="space-y-4"
    >
      <div>
        <label
          htmlFor="forgot-email"
          className="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          Email
        </label>
        <input
          id="forgot-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
          autoComplete="email"
          disabled={loading}
          className="w-full px-4 py-3 border-2 border-transparent rounded-lg bg-primary-500/10 focus:border-primary-500 focus:bg-primary-500/10 outline-none transition text-sm dark:bg-gray-900 disabled:opacity-50"
        />
      </div>

      <CButton
        type="submit"
        size="lg"
        className="w-full"
        disabled={loading || !email}
      >
        {loading ? "Sending..." : "Send reset link"}
      </CButton>
    </form>
  );
};

export default RequestStep;
